//import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/scss/bootstrap.scss';
import './App.css';
import './App.scss';

import AdminLayout from './layouts/AdminLayout';
import LoginScreen from './layouts/auth/LoginScreen';
import { useAuth } from './providers/AuthProvider';
import { WebSocketProvider } from './providers/WebSocketProvider';

function App() {

  const { authData } = useAuth()

  const handleLogin = (token) => {
  }

  if (!authData.token) {
    return <LoginScreen onLogin={handleLogin} />
  }


  return (
    <WebSocketProvider>
      <AdminLayout />
    </WebSocketProvider>
  );
}

export default App;
